
const LoadingStates = ({ message = "Loading...", subMessage = "Please wait" }) => {
  return (
    <div className="ankr-loading-state">
      <div className="ankr-loading-spinner"></div>
      <p>{message}</p>
      <small>{subMessage}</small>
    </div>
  );
};

export default LoadingStates;